var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"common-card-row"},[_c('v-col',{staticClass:"common-card-col"},[_c('p',[_vm._v("Estate Planning")]),_c('div',{staticClass:"container pa-0",attrs:{"id":`con_${_vm.id}`}},[_c('div',{staticClass:"svg-container",attrs:{"id":`${_vm.id}`}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }